/**
 * setMenusu.js — company portal menu items a given interface set does NOT show in the sidebar (#535, 2026-10-21, Deniz).
 * VerticalLayouts/index.js reads it on top of the module rule (PORTAL_MENU_MODULU); pure so jest can try it (setMenusu.test.js).
 *
 * Only the sidebar entry goes: the page itself (route) stays reachable by its address. To bring an entry back delete it from the list.
 * WAS: every set saw every item its modules reached.
 */
export const SET_GIZLI_MENU_OGELERI = {
  // The Yabancı Katılımcı is asked for two company documents only (Documents tab of My Company); the "Required Documents" matrix is noise.
  // #704: no Projects entry either. The simple panel (Sade panel modu) takes this set's key, and a Dekoratör login there still reaches READ in the
  // PROJELER module, so the role check in VerticalLayouts/index.js alone would keep drawing it. The real Yabancı Katılımcı never saw it (KATILIMCI).
  // WAS (until #704): YABANCI_KATILIMCI: ["FirmaBelgeGereksinimleri"],
  YABANCI_KATILIMCI: ["FirmaBelgeGereksinimleri", "FirmaProjeler"],
};

/**
 * `id`: LayoutMenuData item id; `setKodu`: the LAYOUT's set code, services/sadePanel.gorunumSetKodu(portal) (#704: the Yabancı Katılımcı's
 * while Sade panel modu is ON, else the active set's own), or null. WAS (until #704): the active set's code (portal.aktif.kod).
 */
export const setMenusundeGizli = (id, setKodu) => (SET_GIZLI_MENU_OGELERI[setKodu] ?? []).includes(id);
